/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var OrdersIcon = createIcon({
  name: 'OrdersIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M448 156.347l-205.254 237.254 58.508 58.51 146.746-114.744 274.744 242.744 58.1024-58.508zM831.772 822.857c0.078-0.066 0.162-0.15 0.228-0.23v-767.542c-0.066-0.078-0.15-0.162-0.228-0.228h-639.544c-0.080 0.066-0.162 0.15-0.228 0.228v767.544c0.066 0.080 0.15 0.162 0.23 0.228h-128.23v-768c0-70.4 57.6-128 128-128h640c70.4 0 128 57.6 128 128v768h-128.228zM640 822.857v64c0 35.346-28.654 64-64 64h-128c-35.346 0-64-28.654-64-64v-64h-128v-128h1024v128h-128zM576 822.857h-128v64h128v-64z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default OrdersIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/orders-icon.js
// module id = 1205
// module chunks = 0